import React from 'react';

const STEPS = [
    {
        title: 'Download the app',
        text: 'Get Drive.Day free from the App Store or Google Play.',
    },
    {
        title: 'Log in as a pupil',
        text: 'Open the app, choose Pupil and enter the mobile number your instructor has for you.',
    },
    {
        title: 'Enter your code',
        text: "We'll text you a 6-digit code. Enter it and you're in.",
    },
];

function StepsPupilApp() {
    return (
        <section className="dd-pupil-steps pt-100 pb-60">
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-lg-6">
                        <div className="dd-section-title text-center">
                            <h3 className="dd-title">Get started in three steps</h3>
                        </div>
                    </div>
                </div>
                <div className="row">
                    {STEPS.map((step, index) => (
                        <div className="col-lg-4" key={step.title}>
                            <div className="dd-pupil-step">
                                <span className="dd-pupil-step-number">{index + 1}</span>
                                <h4>{step.title}</h4>
                                <p>{step.text}</p>
                            </div>
                        </div>
                    ))}
                </div>
                <p className="dd-pupil-steps-note text-center">
                    Can&apos;t log in? Ask your instructor to check they&apos;ve added your mobile
                    number and invited you to the app.
                </p>
            </div>
        </section>
    );
}

export default StepsPupilApp;
